// Atoms
import Button from './atoms/Button';
import Heading from './atoms/Heading';
import Icon from './atoms/Icon';
import Link from './atoms/Link';
import List from './atoms/List';
import Logo from './atoms/Logo';
import Loading from './atoms/Loading';
import Text from './atoms/Text';
import Spinner from './atoms/Spinner';

// Molecules
import Footer from './molecules/Footer';
import InputField from './molecules/InputField';
import Modal from './molecules/Modal';
import ToolTip from './molecules/ToolTip';
import CardReader from './molecules/CardReader';
import AlertCard from './molecules/AlertCard';
import IncrementalInput from './molecules/IncrementalInput';

// Scaffolds
import VerticalOneColumn from './scaffolds/VerticalOneColumn';

// Types
// Atoms
// import ButtonProps, { ButtonColor, ButtonVariant, ButtonType } from './atoms/Button/Button.types';
// import { HeadingProps, HeadingTags, HeadingTagsType } from './atoms/Heading/Heading.types';
// import IconProps from './atoms/Icon/Icon.types';
// import LinkProps from './atoms/Link/Link.types';
// import ListProps, { ListLayout, ListWrap, ListType } from './atoms/List/List.types';
// import LoadingProps from './atoms/Loading/Loading.types';
// import LogoProps, { LogoImageProps } from './atoms/Logo/Logo.types';
// import TextProps from './atoms/Text/Text.types';

// Molecules
import { AlertTypeValues } from './molecules/AlertCard/AlertCard.types';
// import AlertCardProps, { AlertType, AlertTypeValues } from './molecules/AlertCard/AlertCard.types';
// import CardReaderProps from './molecules/CardReader/CardReader.types';
// import FooterProps from './molecules/Footer/Footer.types';
// import InputFieldProps from './molecules/InputField/InputField.types';
// import ModalProps from './molecules/Modal/Modal.types';

import { AppearsFromValues } from './molecules/ToolTip/ToolTip.types';
// import { ToolTipProps, AppearsFromValues, AppearsFromType } from './molecules/ToolTip/ToolTip.types';

// Scaffolds
// import VerticalOneColumnProps from './scaffolds/VerticalOneColumn/VerticalOneColumn.types';

interface IComponentLibrary {
  [key: string]: (props: any) => JSX.Element;
}

const libraryComponents: IComponentLibrary = {
  // Atoms
  Button,
  Heading,
  Icon,
  Link,
  List,
  Logo,
  Loading,
  Spinner,
  Text,

  // Molecules
  Footer,
  InputField,
  Modal,
  ToolTip,

  // Organisms
  CardReader,
  AlertCard,

  // Scaffolds
  VerticalOneColumn,
};

export default libraryComponents;

export {
  // Atoms
  Button,
  Heading,
  Icon,
  Link,
  List,
  Logo,
  Loading,
  Text,
  // Molecules
  Footer,
  InputField,
  Modal,
  ToolTip,
  IncrementalInput,
  // Organisms
  CardReader,
  AlertCard,
  // Scaffolds
  VerticalOneColumn,
};

// Types
export {
  // Molecules
  // AlertCardProps,
  // AlertType,
  // CardReaderProps,
  // FooterProps,
  // InputFieldProps,
  // ModalProps,
  // ToolTipProps,
  AppearsFromValues,
  AlertTypeValues,
  // AppearsFromType,
  // Scaffolds
  // VerticalOneColumnProps,
};
